import * as formatter from '../formatters/index';
import * as parser from '../parsers/index';
import { FieldModel, NameValueFieldModelProps } from './FieldModel';

export class SortCodeFieldModel extends FieldModel {
  constructor({ name, value }: NameValueFieldModelProps) {
    super({ name, value, formatter: formatter.sortCode as any, parser: parser.sortCode, isValid: parser.isSortCode });
  }
}
